import API from './api';

export const AddLog = data =>
  API.post('/log/actionLog', { ...data, route: window.location.href })
    .then(res => res)
    .catch(err => {
      throw err;
    });
